<template>
  <div class="flex-col py-1 px-2" v-if="enhanceSignatureStore.getOptions(id)">
    <div class="flex gap-1 mb-1">
      <PTooltip :label="dayjs().format('DD/MM/YYYY')" :delay="500" :offset="10" :disabled="disabled">
        <PSelectableTag
          @update:model-value="enhanceSignatureStore.setOptions(id, 'date', $event)"
          :model-value="getEnhanceOptionVal(id, 'date')"
          size="sm"
          :disabled="disabled"
        >
          Date
        </PSelectableTag>
      </PTooltip>
      <PTooltip
        :label="`${authStore.currentUser?.firstName} ${authStore.currentUser?.lastName}`"
        :delay="500"
        :offset="10"
        :disabled="disabled || !authStore.currentUser?.firstName"
      >
        <PSelectableTag
          @update:model-value="enhanceSignatureStore.setOptions(id, 'name', $event)"
          :model-value="getEnhanceOptionVal(id, 'name')"
          size="sm"
          :disabled="disabled || !authStore.currentUser?.firstName"
        >
          Prénom NOM
        </PSelectableTag>
      </PTooltip>
    </div>
    <div class="flex gap-1">
      <PTooltip
        :label="userPreferencesStore.job"
        :delay="500"
        :offset="10"
        :disabled="disabled || !userPreferencesStore.job"
      >
        <PSelectableTag
          @update:model-value="enhanceSignatureStore.setOptions(id, 'job', $event)"
          :model-value="getEnhanceOptionVal(id, 'job')"
          size="sm"
          :disabled="disabled || !userPreferencesStore.job"
        >
          Fonction
        </PSelectableTag>
      </PTooltip>
      <PTooltip
        :label="userPreferencesStore.city"
        :delay="500"
        :offset="10"
        :disabled="disabled || !userPreferencesStore.city"
      >
        <PSelectableTag
          @update:model-value="enhanceSignatureStore.setOptions(id, 'city', $event)"
          :model-value="getEnhanceOptionVal(id, 'city')"
          size="sm"
          :disabled="disabled || !userPreferencesStore.city"
        >
          Ville
        </PSelectableTag>
      </PTooltip>
    </div>
  </div>
</template>

<script setup lang="ts">
import { type EnhanceOptions } from "@/app/dto/enhance-signature.dto.ts";
import { useEnhanceSignatureStore } from "@/app/stores/enhance-signature.store.ts";
import { useUserPreferencesStore } from "@/app/stores/user-preferences.store.ts";
import { PSelectableTag, PTooltip } from "@pasta/box-v2";
import { useAuthStore } from "@pasta/front-auth-v2";
import dayjs from "dayjs";

interface Props {
  id: number;
  disabled?: boolean;
}

withDefaults(defineProps<Props>(), { disabled: false });

const enhanceSignatureStore = useEnhanceSignatureStore();
const userPreferencesStore = useUserPreferencesStore();
const authStore = useAuthStore();

function getEnhanceOptionVal(key: number, optionKey: keyof EnhanceOptions) {
  return enhanceSignatureStore.getValue(key, optionKey);
}
</script>
